import CreateAdmin from './CreateAdmin';
export default CreateAdmin;
